import { hasValue } from "@repo/helpers";

import { Column } from "./models";

/**
 * Builds the rows and headers the grid sends to GenerateExcelFile/GenerateCsvFile.
 * A column whose cell is a React element or other object in any row is left out of every row, because the
 * server writes cells by position and a column dropped partway through would shift later values under the wrong headers.
 */
export function buildExportRows<T>(rows: T[], columns: Column<T>[]) {
	const cells = rows.map((row) => columns.map((column) => exportValue(column, row)));
	const keep = columns.map((_, index) => cells.every((cellsInRow) => !isComplex(cellsInRow[index])));

	return {
		headers: columns.filter((_, index) => keep[index]).map((column) => column.name),
		rows: cells.map((cellsInRow) =>
			cellsInRow.filter((_, index) => keep[index]).map((value) => (hasValue(value) ? value : "")),
		),
	};
}

function exportValue<T>(column: Column<T>, row: T) {
	try {
		return column.getValue(row);
	} catch (e) {
		console.error(`Error getting value for column ${column.name}`, e);
		return "";
	}
}

/** Dates serialize fine; anything else with keys is likely a React element. */
function isComplex(value: unknown) {
	return typeof value === "object" && value !== null && !(value instanceof Date) && Object.keys(value).length > 0;
}
